module.exports = __webpack_public_path__ + "static/user-7a643228c64ce1b9aa69.png";